module.exports = __webpack_public_path__ + "img/acuerdoCapte03.920bb025.jpg";